// extracted by mini-css-extract-plugin
export var searchHeader = "_56-0";
export var searchHeaderDark = "_56-1";